<div class="form-modal">
	<mat-dialog-content>
		<a tabindex="0" (click)="onClose()" (keypress)="onClose()" class="close-modal"
			aria-label="Close organization edit form">
			<img src="./assets/img/icons-svg/close-icon.svg" />
		</a>
		<div class="img-wrapper">
			<div class="clearfix"></div>
			<div class="title-wrapper">
				<h1>{{ title }}</h1>
			</div>
		</div>

		<popup-loader *ngIf="!isLoaded"></popup-loader>
        <ng-container *ngIf="mode === 'create'">
            <form 
                novalidate
                [formGroup]="createDailySeriesForm"
            >
                <div id="resource-section" class="form-wrapper-80" *ngIf="isLoaded">
                        <ng-template mat-tab-label> Import Daily Series Template </ng-template>
                            <h3>- Step 1 -</h3>
                            <p>
                                Download the following spreadsheet and have it filled
                                out by the client.
                            </p>
                            <a href="/assets/documents/daily-series-template.xlsx" download>
                                Download Template
                            </a>
        
                            <h3>- Step 2 -</h3>
                                <mat-form-field class="wt-mat-form-field">
                                    <input matInput formControlName="title" required class="wt-mat-input" placeholder="Title" type="text" />
                                    <mat-error *ngIf="f.title.touched && f.title.errors?.required">
                                        Title is required
                                    </mat-error>
                                </mat-form-field>
                                <div class="icon-input">
                                    <label for="resources" translate
                                        >Import Resources</label
                                    >
                                    <div>
                                        <input
                                            type="file"
                                            style="display: inline-block"
                                            (change)="incomingfile($event)"
                                            placeholder="Upload file"
                                            accept=".xlsx"
                                        />
                                    </div>
                                    <span
                                        class="text-danger"
                                        *ngIf="
                                            fileError === '' &&
                                            f.excelFile.touched &&
                                            f.excelFile.errors?.required
                                        "
                                    >
                                        Please upload the file to import
                                    </span>
                                    <span class="text-danger" *ngIf="fileError !== ''">
                                        {{ fileError }}
                                    </span>
                                </div>
                                <!-- <button
                                    tabindex="0"
                                    class="btn-primary btn-bold btn"
                                >Import</button> -->
                    <div class="fixed-footer">
                        <p class="red" *ngIf="submitButtonPressed && !createDailySeriesForm.valid && errors === ''">Please check the errors</p>
                        <p class="red">{{errors}}</p>
                        <a tabindex="0" class="btn-primary btn-bold btn" (click)="doSave()" (keypress)="doSave()">Save</a>
                    </div>
                </div>
            </form>
        </ng-container>
        <ng-container *ngIf="mode !== 'create'">
            <form novalidate [formGroup]="courseEditForm">
                <div id="dailyseries-section" class="form-wrapper-80" *ngIf="isLoaded">
            
                    <mat-form-field class="wt-mat-form-field">
                        <mat-label for="category" translate>Course Category</mat-label>
                        <mat-select formControlName="category">
                            <mat-option *ngFor="let category of categoryList" [value]="category.ID">
                                {{ category.Title }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="wt-mat-form-field">
                        <mat-label>Daily Boost - English</mat-label>
                        <textarea matInput placeholder="Daily Boost - English" formControlName="quotesen"></textarea>
                        <!-- <input matInput formControlName="quotesen" required class="wt-mat-input" placeholder="Quote (English)"
                            type="text" /> -->
                        <mat-error *ngIf="g.quotesen.touched && g.quotesen.errors?.required">
                            The Quote (English) is required
                        </mat-error>
                    </mat-form-field>
            
                    <mat-form-field appearance="outline" class="wt-mat-form-field">
                        <mat-label>Daily Boost - French</mat-label>
                         <textarea matInput placeholder="Daily Boost - French" formControlName="quotesfr"></textarea>
                        <!-- <input matInput class="wt-mat-input" required placeholder="Quote (French)" type="text"
                            formControlName="quotesfr" /> -->
                        <mat-error *ngIf="g.quotesfr.touched && g.quotesfr.errors?.required">
                            The Quote (French) is required
                        </mat-error>
                    </mat-form-field>
            
                    <mat-form-field appearance="outline" class="wt-mat-form-field">
                        <mat-label>Daily Boost - Spanish</mat-label>
                         <textarea matInput placeholder="Daily Boost - Spanish" formControlName="quoteses"></textarea>
                        <!-- <input matInput class="wt-mat-input" required placeholder="Quote (Spanish)" type="text"
                            formControlName="quoteses" /> -->
                        <mat-error *ngIf="g.quoteses.touched && g.quoteses.errors?.required">
                            The Quote (Spanish) is required
                        </mat-error>
                    </mat-form-field>
            
                    <div class="fixed-footer">
                        <p class="red" *ngIf="submitButtonPressed && !courseEditForm.valid && errors === ''">Please check the errors
                        </p>
                        <p class="red">{{errors}}</p>
                        <a tabindex="0" class="btn-primary btn-bold btn" (click)="doSave()" (keypress)="doSave()">Save</a>
                    </div>
                </div>
            </form>
        </ng-container>
	</mat-dialog-content>
</div>
